export var CampaignStatusEnum;
(function (CampaignStatusEnum) {
    CampaignStatusEnum["VALIDATION_ERROR"] = "VALIDATION_ERROR";
    CampaignStatusEnum["SYSTEM_ERROR"] = "SYSTEM_ERROR";
    CampaignStatusEnum["FAILED"] = "FAILED";
    CampaignStatusEnum["RETRY"] = "RETRY";
    CampaignStatusEnum["IN_QUEUE"] = "IN_QUEUE";
    CampaignStatusEnum["PROCESSING"] = "PROCESSING";
    CampaignStatusEnum["PROCESSED"] = "PROCESSED";
})(CampaignStatusEnum || (CampaignStatusEnum = {}));
//# sourceMappingURL=CampaignStatusEnum.js.map